"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8548],{

/***/ 2568:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TermAndPolicyText; }
/* harmony export */ });
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8756);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97204);




const Text = _teko_ui__WEBPACK_IMPORTED_MODULE_1__/* .styled.a */ .z.a `
  &,
  &:hover,
  &:focus,
  &:visited {
    color: #047fff;
    text-decoration: none;
  }
`;
const TermAndPolicyText = ({ link = 'https://help.phongvu.vn', text = (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_2__.t)('điều kiện sử dụng và chính sách'), className, }) => {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(Text, { href: link, target: "_blank", rel: "noopener noferrer", className: className, onClick: (event) => {
            event.stopPropagation();
        } }, text));
};




/***/ }),

/***/ 39910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91806);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89703);
/* harmony import */ var _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97204);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79690);





const StyledCheckbox = _libs_styled_es_js__WEBPACK_IMPORTED_MODULE_2__/* .styled.div */ .z.div(styled_system__WEBPACK_IMPORTED_MODULE_1__.space, ({ theme, checked, circle, indeterminate = false, width, height }) => {
    const checkedColor = checked || indeterminate ? theme.brand.primary : '#BCBFD6';
    const styles = {
        width,
        height,
        border: circle || !checked ? `1px solid ${checkedColor}` : 'none',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        overflow: 'hidden',
    };
    if (circle) {
        styles.borderRadius = '50% !important';
    }
    if (checked || indeterminate) {
        styles['&:after'] = {
            content: '" "',
            width: `calc(${width} - ${circle || indeterminate ? 6 : 0}px)`,
            height: `calc(${height} - ${circle || indeterminate ? 6 : 0}px)`,
            backgroundColor: checkedColor,
            borderRadius: circle ? '50%' : 'initial',
        };
        if (checked && !circle) {
            styles['&:before'] = {
                position: 'absolute',
                display: 'table',
                border: '2px solid #fff',
                borderTop: 0,
                borderLeft: 0,
                transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                transition: 'all .2s cubic-bezier(.12,.4,.29,1.46) .1s',
                content: '" "',
                top: '44%',
                left: '50%',
                width: '5px',
                height: '9px',
                transformOrigin: 'left top',
            };
        }
    }
    return styles;
});
const Checkbox = (_a) => {
    var { className, width = '0.9rem', height = '0.9rem' } = _a, rest = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__rest */ ._T)(_a, ["className", "width", "height"]);
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCheckbox, Object.assign({ width: width, height: height }, rest, { className: className })));
};




/***/ }),

/***/ 22097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kD": function() { return /* binding */ SUBSCRIBE; },
/* harmony export */   "V9": function() { return /* binding */ CONFIRM_UNSUBSCRIBE; }
/* harmony export */ });
/* unused harmony export MOBIO_SUBSCRIPTION_MAP */
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47248);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var SUBSCRIBE_UNMAP = [
    {
        title: 'Bản tin khuyến mại',
        alternative: false,
        type: 'checkbox',
        description: '',
        options: [
            {
                text: 'Bản tin khuyến mại (1 lần/tuần)',
                name: 'SUB_PROMOTION_WEEK_YES'
            },
            {
                text: 'Bản tin khuyến mại th\xe1ng (1 lần/th\xe1ng)',
                name: 'SUB_PROMOTION_MONTH_YES'
            },
            {
                text: 'C\xe1c th\xf4ng tin khuyến mại v\xe0 th\xf4ng tin giảm gi\xe1 hấp dẫn với <b>số lượng giới hạn chỉ d\xe0nh ri\xeang cho bạn</b>',
                name: 'SUB_PROMOTION_UNIQUE_YES'
            },
            {
                text: 'Khuyến m\xe3i tri \xe2n Kh\xe1ch h\xe0ng th\xe2n thiết trong chương tr\xecnh Membership Loyalty',
                name: 'SUB_PROMOTION_LOYALTY_YES'
            }, 
        ]
    },
    {
        title: 'Bản tin c\xf4ng nghệ',
        alternative: false,
        type: 'checkbox',
        description: '',
        options: [
            {
                text: 'G\xf3c c\xf4ng nghệ: giới thiệu c\xe1c sản phẩm c\xf4ng nghệ mới nhất',
                name: 'SUB_NEWS_TECH_YES'
            },
            {
                text: 'G\xf3c Gaming: tất tần tật về gaming v\xe0 gamer, c\xe1c giải đấu esport đỉnh cao',
                name: 'SUB_NEWS_GAME_YES'
            },
            {
                text: 'G\xf3c thủ thuật: hướng dẫn c\xe1c thủ thuật m\xe1y t\xednh v\xe0 c\xf4ng nghệ ứng dụng cao trong cuộc sống từ chuy\xean gia Phong Vũ',
                name: 'SUB_NEWS_TIPS&TRICKS_YES'
            }, 
        ]
    },
    {
        title: 'Thư mời tham dự event',
        alternative: false,
        type: 'checkbox',
        description: '',
        options: [
            {
                text: 'Giải đấu esport do Phong Vũ tổ chức/t\xe0i trợ',
                name: 'SUB_EVENT_ESPORT_YES'
            },
            {
                text: 'Event miễn ph\xed trải nghiệm sản phẩm do Phong Vũ v\xe0 c\xe1c đối t\xe1c tổ chức t\xe0i trợ',
                name: 'SUB_EVENT_EXPERIENCE_YES'
            }, 
        ]
    }, 
];
var CONFIRM_UNSUBSCRIBE_UNMAP = [
    {
        title: 'Chọn l\xfd do',
        alternative: true,
        type: 'checkbox',
        description: '',
        options: [
            {
                text: 'Th\xf4ng tin gửi với tần suất qu\xe1 nhiều',
                name: 'UNSUB_REASON_FREQUENTLY'
            },
            {
                text: 'T\xf4i bấm nhầm đăng k\xfd nhận th\xf4ng tin đ\xf3',
                name: 'UNSUB_REASON_MISTAKE'
            },
            {
                text: 'T\xf4i kh\xf4ng phải l\xe0 kh\xe1ch h\xe0ng của Phong Vũ',
                name: 'UNSUB_REASON_CUSTOMEROFPV'
            },
            {
                text: 'L\xfd do kh\xe1c',
                name: 'UNSUB_OTHER_REASONS'
            }, 
        ]
    },
    {
        title: 'Hmmm! Bạn cần th\xeam ch\xfat thời gian để c\xe2n nhẵc? Phong Vũ c\xf3 thể li\xean lạc lại bạn sau:',
        description: 'Phong Vũ rất tiếc về những trải nghiệm chưa tốt hiện tại.<br/>Ch\xfang t\xf4i lu\xf4n lắng nghe phản hồi để c\xf3 sự phục vụ tốt nhất tới bạn',
        alternative: false,
        options: [
            {
                text: '1 th\xe1ng',
                name: 'UNSUB_1M'
            },
            {
                text: '2 th\xe1ng',
                name: 'UNSUB_2M'
            },
            {
                text: '3 th\xe1ng',
                name: 'UNSUB_3M'
            },
            {
                text: '6 th\xe1ng',
                name: 'UNSUB_6M'
            }, 
        ],
        type: 'radio'
    }, 
];
var DEFAULT_MOBIO_SUBSCRIPTION = JSON.stringify({
    SUB_PROMOTION_WEEK_YES: '3b60f0e5-b761-40d7-8986-d12e44b9227d',
    SUB_PROMOTION_MONTH_YES: '01ab55f8-c24a-4825-b5b7-9af25f68cde1',
    SUB_PROMOTION_UNIQUE_YES: '1ffac4f5-ffcf-437c-aac3-8a6a311de8b3',
    SUB_PROMOTION_LOYALTY_YES: 'f791f16c-6b6c-4539-9c63-d1afcc35e92c',
    SUB_NEWS_TECH_YES: 'e4cea947-abb8-4d42-b04e-477955e952bf',
    SUB_NEWS_GAME_YES: 'a4686880-eb0a-497f-a3d8-f7e7d71f967b',
    'SUB_NEWS_TIPS&TRICKS_YES': '8b9d99a7-4915-4795-a48c-1d37de32ce48',
    SUB_EVENT_ESPORT_YES: '4824b95b-c00a-41d5-a77c-4c4449cad257',
    SUB_EVENT_EXPERIENCE_YES: '1bd00d9c-bfb0-453e-9f2b-467e3fbff0a1',
    UNSUB_REASON_FREQUENTLY: '8bff27fd-3e2d-469a-923b-311ef5c56b48',
    UNSUB_REASON_MISTAKE: '4a61834d-b646-4f37-88e8-8f5dac1c2447',
    UNSUB_REASON_CUSTOMEROFPV: 'ecdba4f1-6a36-4e84-a323-9bfe54a4cbe4',
    UNSUB_OTHER_REASONS: '8c87b9ba-ee2a-444e-b851-431405ba7a83',
    UNSUB_1M: 'eb354daf-10dd-4a8e-8594-1b833f0e55b6',
    UNSUB_2M: '9fd5c48b-0203-49c6-8211-8376b4c378d9',
    UNSUB_3M: 'f03e69a8-86a2-4c39-bfb0-2c7cc9e62ad5',
    UNSUB_6M: '3d981201-d892-4c02-86d2-ebb1042d157a'
});
var MOBIO_SUBSCRIPTION_MAP = JSON.parse( true ? lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(window, 'env.MOBIO_SUBSCRIPTION', DEFAULT_MOBIO_SUBSCRIPTION) : 0);
function mapNameWithID(selectionGroup) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = selectionGroup[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ref = _step.value;
            var group = _ref;
            var _tmp;
            _tmp = group.options.map(function(_param) {
                var name = _param.name, rest = _objectWithoutProperties(_param, [
                    "name"
                ]);
                return _objectSpread({}, rest, {
                    name: name,
                    id: MOBIO_SUBSCRIPTION_MAP[name]
                });
            }), group.options = _tmp, _tmp;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return selectionGroup;
}
var SUBSCRIBE = mapNameWithID(SUBSCRIBE_UNMAP);
var CONFIRM_UNSUBSCRIBE = mapNameWithID(CONFIRM_UNSUBSCRIBE_UNMAP);


/***/ }),

/***/ 18548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ MobioContext; },
/* harmony export */   "t": function() { return /* binding */ MobioContextProvider; }
/* harmony export */ });
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71421);
/* harmony import */ var _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20348);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17963);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89703);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97204);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39910);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28697);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2568);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47248);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22097);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43476);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84982);
/* harmony import */ var _services__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(33141);











function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0.9375rem;\n  line-height: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  color: #434657;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: 0.8125rem;\n  color: #82869e;\n  margin-bottom: 1rem;\n  line-height: 1.125rem;\n  font-weight: 400;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n  margin-top: 3px;\n  border-radius: 2px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  margin: 0;\n  margin-left: 0.5rem;\n  cursor: pointer;\n  user-select: none;\n  line-height: 1.125rem;\n  font-weight: 400;\n  font-size: 0.8125rem;\n  color: #434657;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  cursor: pointer;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
var defaultValues = {
    mobioProfile: {},
    updateTags: function(_) {
        return _;
    }
};
var MobioContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createContext)(defaultValues);
var Modal = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(function(param) {
    var showAnimation = param.showAnimation, startAnimation = param.startAnimation, isMobile = param.isMobile;
    return "\n    background-color: white;\n    position: fixed;\n    ".concat(!isMobile ? 'left: 2vw;' : "\n          transform: translate(-50%, -50%);\n          left: 50%;\n        ", "\n    padding: 1rem;\n    box-shadow: 5px 5px 20px 1px rgba(0, 0, 0, 0.1);\n    width: 21rem;\n    border-radius: 3px;\n    z-index: 10000;\n    visibility: ").concat(startAnimation ? 'initial' : 'hidden', ";\n    opacity: ").concat(showAnimation ? '1' : '0', ";\n    animation: ").concat(showAnimation ? 'slideUp' : 'slideDown', ";\n    bottom: ").concat(showAnimation ? '5vh' : '-20vh', ";\n    animation-duration: 0.3s;\n    animation-timing-function: ease-in-out;\n    animation-iteration-count: 1;\n\n    @keyframes slideUp {\n      0% {\n        opacity: 0;\n        bottom: -20vh;\n      }\n      100% {\n        opacity: 1;\n        bottom: 5vh;\n      }\n    } \n\n    @keyframes slideDown {\n      0% {\n        opacity: 1;\n        bottom: 5vh;\n      }\n      100% {\n        opacity: 0;\n        bottom: -20vh;\n      }\n    }\n  ");
});
var ModalHeader = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.p */ .z.p(_templateObject());
var ModalDescription = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.p */ .z.p(_templateObject1());
var ModalFooter = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.div */ .z.div(_templateObject2());
var StyledCheckbox = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_6__/* .Checkbox */ .X)(_templateObject3());
var Text = _teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled.p */ .z.p(_templateObject4());
var StyledSvgIcon = (0,_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .styled */ .z)(_teko_ui__WEBPACK_IMPORTED_MODULE_7__/* .SvgIcon */ .l)(_templateObject5());
var TOTAL_COUNT_DOWN = 5000;
var MobioContextProvider = function(param1) {
    var children = param1.children;
    var ref = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)(), myProfile = ref.user;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isSubscribe = ref1[0], setIsSubscribe = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showModal = ref2[0], setShowModal = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), startShowModal = ref3[0], setStartShowModal = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}), mobioProfile = ref4[0], setMobioProfile = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isTimeout = ref5[0], setIsTimeout = ref5[1];
    var isMobile = (0,_contexts__WEBPACK_IMPORTED_MODULE_8__/* .useGlobalData */ .U5)().isMobile;
    var updateTags = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(profileTags) {
        setMobioProfile(function(prev) {
            return _objectSpread({}, prev, {
                profile_tags: profileTags
            });
        });
    }, []);
    var customerId1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(mobioProfile, 'id');
    }, [
        mobioProfile
    ]);
    var subscribe = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(customerId) {
        if (customerId) {
            var subscribeTags = _constants__WEBPACK_IMPORTED_MODULE_9__/* .SUBSCRIBE.reduce */ .kD.reduce(function(total, param) {
                var options = param.options;
                return _toConsumableArray(total).concat(_toConsumableArray(options.map(function(option) {
                    return option.id;
                })));
            }, []);
            var unsubscribeTags = _constants__WEBPACK_IMPORTED_MODULE_9__/* .CONFIRM_UNSUBSCRIBE.reduce */ .V9.reduce(function(total, param) {
                var options = param.options;
                return _toConsumableArray(total).concat(_toConsumableArray(options.map(function(option) {
                    return option.id;
                })));
            }, []);
            _services__WEBPACK_IMPORTED_MODULE_10__/* .mobioService.updateMobioTags */ .U.updateMobioTags(customerId, subscribeTags, unsubscribeTags).then(function(param) {
                var data = param.data;
                return updateTags(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(data, 'data.profile_info.profile_tags') || []);
            });
        }
    }, [
        updateTags
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        _asyncToGenerator(_app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var alternateEmail, mobioProfileResponse, profile, createMobioProfileResponse, time;
            return _app_yarn_virtual_next_virtual_b4cbbda601_0_cache_next_npm_12_0_9_6852d2b6ac_e01e3dbe8b_zip_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!myProfile) {
                            _ctx.next = 18;
                            break;
                        }
                        alternateEmail = !myProfile.email && !myProfile.telephone ? "".concat(myProfile.userId, "@teko.vn") : '';
                        _ctx.next = 4;
                        return _services__WEBPACK_IMPORTED_MODULE_10__/* .mobioService.getProfile */ .U.getProfile(myProfile.telephone || myProfile.email || alternateEmail);
                    case 4:
                        mobioProfileResponse = _ctx.sent;
                        if (!lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(mobioProfileResponse, 'errors')) {
                            _ctx.next = 7;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 7:
                        profile = lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(mobioProfileResponse, 'data.customers.0');
                        if (!profile) {
                            _ctx.next = 11;
                            break;
                        }
                        setMobioProfile(profile);
                        return _ctx.abrupt("return");
                    case 11:
                        _ctx.next = 13;
                        return _services__WEBPACK_IMPORTED_MODULE_10__/* .mobioService.createMobioProfile */ .U.createMobioProfile(myProfile.name || '', myProfile.telephone || '', myProfile.email || alternateEmail);
                    case 13:
                        createMobioProfileResponse = _ctx.sent;
                        setMobioProfile(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(createMobioProfileResponse, 'data.profile_info'));
                        time = setTimeout(function() {
                            setIsTimeout(true);
                            clearTimeout(time);
                        }, TOTAL_COUNT_DOWN);
                        setStartShowModal(true);
                        setShowModal(true);
                    case 18:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        myProfile
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isTimeout) {
            if (isSubscribe) {
                subscribe(customerId1);
            }
            setShowModal(false);
        }
    }, [
        isTimeout,
        isSubscribe,
        customerId1,
        subscribe
    ]);
    var handleClick = function() {
        setIsSubscribe(function(prev) {
            return !prev;
        });
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(MobioContext.Provider, {
        value: {
            mobioProfile: mobioProfile,
            updateTags: updateTags
        },
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Modal, {
                showAnimation: showModal,
                startAnimation: startShowModal,
                isMobile: isMobile,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSvgIcon, {
                        name: "close",
                        onClick: function() {
                            return setShowModal(false);
                        },
                        size: 12,
                        color: "#adadad"
                    }),
                    !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalHeader, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)('Nhận th\xf4ng tin khuyến m\xe3i')
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ModalDescription, {
                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)('MobioContext.0')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ModalFooter, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledCheckbox, {
                                width: "1rem",
                                height: "1rem",
                                checked: isSubscribe,
                                onClick: handleClick
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Text, {
                                onClick: handleClick,
                                children: [
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)('T\xf4i đồng \xfd với'),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_12__/* .TermAndPolicyText */ .v, {}),
                                    (0,i18n__WEBPACK_IMPORTED_MODULE_11__.t)('của Phong Vũ')
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 33141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ mobioService; }
/* harmony export */ });
/* unused harmony export normalizeParams */
/* harmony import */ var _clients__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75540);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82957);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24105);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var merchantId = (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getEnv */ .dU)('MOBIO_MERCHANT_ID');
var token = (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getEnv */ .dU)('MOBIO_TOKEN');
var fieldMap = {
    subscribeTags: 'lst_tag_unsubscribe',
    unsubscribeTags: 'lst_tag_unsubscribe_deleted',
    otherReason: (0,_helpers__WEBPACK_IMPORTED_MODULE_0__/* .getEnv */ .dU)('MOBIO_OTHER_REASON_FIELD')
};
var normalizeParams = function(params) {
    var normalizedParams = {};
    var mappingFields = Object.keys(fieldMap);
    Object.keys(params).forEach(function(field) {
        var data = params[field];
        if (~mappingFields.indexOf(field)) {
            normalizedParams[fieldMap[field]] = data;
        } else {
            normalizedParams[field] = data;
        }
    });
    return normalizedParams;
};
var MOBIO_REQUEST_HEADER = {
    headers: {
        Authorization: "Basic ".concat(token),
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'X-Merchant-ID': merchantId
    }
};
var mobioService = {
    getProfile: function(phoneOrEmail) {
        return _clients__WEBPACK_IMPORTED_MODULE_1__/* .mobioApi.get */ .T3.get('/profiling/v3.0/customers/thirdparty_search_users', _objectSpread({
            params: {
                query: phoneOrEmail
            }
        }, MOBIO_REQUEST_HEADER));
    },
    createMobioProfile: function(customerName, customerPhone, customerEmail) {
        var customer = {
            name: customerName,
            phone_number_1: customerPhone,
            email_1: customerEmail
        };
        return _clients__WEBPACK_IMPORTED_MODULE_1__/* .mobioApi.post */ .T3.post("/profiling/v3.0/merchants/".concat(merchantId, "/customers/actions/create"), {
            customer: customer
        }, MOBIO_REQUEST_HEADER);
    },
    updateProfile: function updateProfile(customerId, customerName, customerPhone, customerEmail) {
        var customer = (0,_helpers__WEBPACK_IMPORTED_MODULE_2__/* .removeNullField */ .jU4)({
            name: customerName,
            phone_number_1: customerPhone,
            email_1: customerEmail
        });
        return _clients__WEBPACK_IMPORTED_MODULE_1__/* .mobioApi.patch */ .T3.patch("/profiling/v3.0/merchants/".concat(merchantId, "/customers/actions/update/").concat(customerId), {
            customer: customer
        }, MOBIO_REQUEST_HEADER);
    },
    updateMobioTags: function(customerId, subscribeTags, unsubscribeTags, otherReason) {
        return _clients__WEBPACK_IMPORTED_MODULE_1__/* .mobioApi.put */ .T3.put("/profiling/v3.0/df/profile/".concat(customerId, "/unsubscribe"), _objectSpread({}, normalizeParams({
            subscribeTags: subscribeTags,
            unsubscribeTags: unsubscribeTags,
            otherReason: otherReason
        })), MOBIO_REQUEST_HEADER);
    }
};


/***/ })

}]);